export const ZERO_WIDTH_SPACE = '\u200C';
// see https://en.wikipedia.org/wiki/Zero-width_non-joiner
export const ZERO_WIDTH_NON_JOINER = '\u200B';

export const INLINE_ROOT_ATTR = 'data-v-root';
